const tennants = {
	title: "Tenants",
	new_tennant: "New Tenant",
	edit_tennant: "Edit Tenant",
	view_tennant: "View Tenant",
	list_title: "List of Tenants",
	list_subtitle: "Manage tenants",
	create_title: "Create New Tenant",
	update_title: "Update Tenant",
	address_title: "Address",
	details_title: "Tenant Details",
	database_title: "Database Details",
	id: "ID",
	subdomain: "Subdomain",
	tenant_company: "Tenant company",
	dbname: "Database Name",
	master_username: "Master Username",
	master_password: "Master Password",
	email: "Email",
	first_name: "First Name",
	last_name: "Last Name",
	mobile: "Mobile",
	status: "Status",
	type: "Type",
	active_from: "Active From",
	inactive_from: "Inactive From",
	payed_for_users: "Payed for Users",
	no_active_users: "No. of Active Users",
	setup: "Setup",
	run_migration: "Run DB Migration",
	run_migration_short: "Migrate",
	db_migration_success: "Database migration success",
	confirm_text: "Enter subdomain name of the tenant you want to delete",
	confirm_text_not_match: "Subdomain does not match",
	activate_now_later: "Do you want to activate the tenant now or later?",
	btn_now: "Now",
	btn_later: "Later",
	sms_service: "SMS Service Status",
	last_migrated_at: "Last Migrated At",
	help_tenant_database: "Fields are automatically populated. Do not edit.",
	select_tenant_type_first: "Select tenant type first",
	tenant_migration_warning: "Tenants will be updated. Do you want to proceed?",
	course_id_increment_start: "Course id start number",
	course_id_increment_start_helptext: "Set a start number for course id. Cannot be changed after migration.",
	connection_name: "Connection name",
	tenant_vat_number: "Tenant VAT number",
	notif_email_from: "Notification email sender",
	notif_sms_from: "Notification sender number",
	swagger_token: "Swagger Token",
	checklist_status: "Checklists status",
	notif_email_not_verified: "Email not verified. Check your inbox",
	notif_email_verified: "Verified",
	resend_verify: "Resend/Verify",
};
export default tennants;